export default {
    login_register: 'Iniciar sesión/Registrarse',
    booking_confirmation_title: 'Confirmación de reserva',
    booking_confirmation_body: 'Gracias por su reserva. Por favor, consulte los detalles de la confirmación a continuación.',
    insurance_requirements_modal_disclaimer: `Al realizar esta reserva, confirmo que: no he tenido condenas ni infracciones de tráfico en los últimos 5 años. No se me ha rechazado ninguna propuesta, cancelado ninguna póliza ni denegado ninguna renovación, ni se me ha exigido pagar una prima más alta ni se me han impuesto condiciones especiales por parte de ningún asegurador de automóviles. No he sido descalificado para conducir. No tengo ningún proceso judicial ni investigación policial pendiente. No tengo condenas por delitos relacionados con robo, fraude o deshonestidad en los últimos 5 años. No sufro de visión o audición defectuosa (no corregida con gafas o audífono), trastorno cardíaco, diabetes, convulsiones o cualquier tipo de discapacidad física o mental. No he tenido accidentes en los últimos 5 años. Por favor, haga clic en {0} si no cumple con estos requisitos.`,
    insurance_requirements_here: 'aquí',
    insurance_requirements: 'He leído y entendido los {0}',
    ir: 'Requisitos de seguro',
    location: 'Ubicación',
    pickup_location: 'Lugar de recogida',
    dropoff_location: 'Lugar de devolución',
    vehicle: 'Vehículo',
    pickup_and_dropoff: 'Recogida y devolución (hora local)',
    view_voucher: 'Ver cupón',
    identity_verification_body: 'Se le pedirá que verifique su identidad antes de recoger el vehículo',
    identity_verification_title: 'Verificar identidad',
    search_again: 'Buscar de nuevo',
    refrigerated: 'refrigerado',
    aircon_lower: 'aire acondicionado',
    aircon: 'Aire acondicionado',
    refrigeration: 'Refrigerado',
    not_available: 'Drive & Go solo está disponible actualmente para personas con documentos de identidad y licencia de conducir de los siguientes países.',
    check_if_included: 'Compruebe si su país está incluido.',
    included_in_booking: 'Incluido en esta reserva',
    cdw_with_excess: 'CDW con franquicia',
    theft_protection: 'Protección contra robo con franquicia',
    risk_reduction: 'Reducción de riesgo',
    free_extras: 'Tiene derecho a dos extras gratuitos <br /> con esta reserva.',
    continue: 'Continuar',
    luggage_large_short_label: 'G',
    luggage_medium_short_label: 'M',
    luggage_small_short_label: 'P',
    luggage_large_long_label: 'grande',
    luggage_medium_long_label: 'mediano',
    luggage_small_long_label: 'pequeño',
    fuel_unspecified_label: 'no especificado',
    transmission_manual_label: 'Manual',
    transmission_automatic_label: 'Automático',
    make_a_booking: 'Hacer una reserva',
    pickup_date: 'Fecha de recogida',
    dropoff_date: 'Fecha de devolución',
    driver_age: 'Conductor entre 30 - 65',
    enter_driver_age: 'Por favor, introduzca la edad del conductor',
    promo_code: 'Código promocional',
    search: 'Buscar',
    dropoff_date_cannot_be_before_pickup_date: 'La fecha de devolución no puede ser anterior a la fecha de recogida',
    pickup_date_cannot_be_in_the_past: 'La fecha de recogida no puede estar en el pasado',
    pickup_time_cannot_be_in_the_past: 'La hora de recogida no puede estar en el pasado',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'La hora de devolución debe ser posterior a la hora de recogida si es el mismo día',
    vehicle_filters: 'Filtros de vehículos',
    reset: 'Restablecer',
    transmission: 'Transmisión',
    all: 'Todos',
    manual: 'Manual',
    auto: 'Automático',
    passengers: 'Pasajeros',
    vehicle_type: 'Tipo de vehículo',
    filter: 'Filtrar',
    vehicle_search: 'Búsqueda de vehículos',
    edit: 'Editar',
    no_results: 'No hay resultados que coincidan con sus criterios.',
    small_cars: 'Coches pequeños',
    medium_cars: 'Coches medianos',
    large_cars: 'Coches grandes',
    estate_cars: 'Rancheras',
    suvs: 'SUVs',
    mpvs: 'MPVs',
    vans: 'Furgonetas',
    camper_vans: 'Autocaravanas',
    premium: 'Premium',
    unspecified: 'no especificado',
    large: 'grande',
    medium: 'mediano',
    small: 'pequeño',
    automatic: 'automático',
    you_have_been_refunded: 'Se le ha reembolsado.',
    please_customer_service: 'Para hacer una reserva, por favor contacte con nuestro servicio de atención al cliente.',
    contact_customer_service: 'Contactar atención al cliente',
    booking_failed: 'Su reserva no pudo ser procesada esta vez.',
    summary: 'Resumen',
    reforestation_and_protection: 'Apoye la reforestación y protección de la selva tropical en toda Costa Rica',
    cost_of_rental: 'Costo del alquiler',
    to_pay_now: 'A pagar ahora',
    greenheart_donation: 'Donación Green Heart',
    total_cost: 'Costo total del alquiler',
    tc_agreement: 'He leído y entendido los {0}.',
    tc: 'Términos y condiciones',
    receive_offers: 'Me gustaría recibir ofertas especiales por correo electrónico.',
    donate: 'Sí, me gustaría donar {amount}',
    pay_now: 'Pagar {amount} ahora',
    driver_details: 'Datos del conductor',
    complete_driver_details: 'Por favor, complete los datos del conductor.',
    are_you_the_driver: '¿Es usted el conductor?',
    have_an_account: '¿Ya tiene una cuenta?',
    login: 'Iniciar sesión',
    or: 'o',
    first_name: 'Nombre del conductor',
    last_name: 'Apellido del conductor',
    email: 'Correo electrónico',
    phone_number: 'Número de teléfono móvil',
    unable_to_save_driver_information: 'No se pudo guardar la información del conductor. Por favor, inténtelo de nuevo.',
    pay_online_now: 'Pagar ahora',
    day: 'Día',
    choose_location: 'Elija una ubicación',
    location_not_found: 'Lo sentimos, no pudimos encontrar la ubicación solicitada.',
    add: 'Agregar',
    remove: 'Eliminar',
    free_extra: 'Extra gratis',
    free: '¡GRATIS!',
    fast_track_notice: 'Se aplican restricciones de origen de documentos para este servicio. Solo está disponible para personas con documentos de',
    complete_booking: 'Completar reserva',
    choose_card: 'Por favor, elija una tarjeta o agregue una nueva.',
    add_billing_details: 'Por favor, agregue los datos de facturación.',
    card_number: 'Número de tarjeta',
    card_holder_name: 'Nombre del titular',
    card_exp: 'MM / AA',
    card_cvc: 'CVC',
    save_card: '¿Guardar tarjeta?',
    amount_charged: 'Se cargará a su tarjeta',
    payment_confirmation: 'Confirmar reserva y pagar',
    payment_methods: 'métodos de pago disponibles',
    use_saved_card: 'x usar tarjeta guardada',
    use_different_card: '+ usar otra tarjeta',
    book_now: 'Reservar ahora',
    minimum_age: 'Solo mayores de {age}',
    excess_liability: 'Franquicia',
    security_deposit: 'Depósito de seguridad',
    fuel_policy: 'Política de combustible',
    like_for_like: 'Igual por igual',
    full_to_full: 'Lleno a lleno',
    miles_per_rental: '{mileage} millas gratis por alquiler',
    km_per_rental: '{mileage} km gratis por alquiler',
    unlimited_mileage: 'Kilometraje ilimitado',
    unlimited_mileage_km: 'Kilómetros ilimitados',
    non_amendable: 'No modificable',
    non_refundable: 'No reembolsable',
    free_cancellation_until: 'Cancelación gratuita hasta',
    cancellation_in_line_with: 'Cancelación según',
    tcs: 'Términos y condiciones',
    free_extras_on_collection: 'Dos extras gratuitos al recoger',
    glass_and_tyres_covered: 'Cristales y neumáticos cubiertos',
    number_of_passengers: 'Número de pasajeros',
    number_of_bags: 'Número de maletas',
    fuel_type: 'Tipo de combustible',
    co2: 'CO2',
    book_type: 'Reservar {type}',
    processing: 'Procesando',
    actual_price: 'Precio real',
    tooltip: 'El precio en {currencyCode} es un estimado basado en el tipo de cambio, el precio en {currency} es vinculante.',
    deposit: 'Depósito',
    pay_online: 'Pagar ahora',
    pay_online_without_extras: 'Precio del alquiler',
    extras_on_arrival: 'Extras al llegar',
    insurance_on_arrival: 'Reducción de riesgo - Pagar al llegar',
    insurance_online: 'Reducción de riesgo - Pagar ahora',
    extras_online: 'Extras - pagar ahora',
    green_heart_donation: 'Donación Green Heart',
    why_use_drive_and_go: '¿Por qué usar Drive & Go?',
    straight_to_car: 'Directo al coche',
    no_queues: 'Sin colas',
    self_checkout: 'Auto check-out',
    cant_lose_key: 'No se puede perder la llave',
    online_id_check: 'Verificación de identidad en línea',
    phone_as_key: 'Teléfono como llave',
    premiumplus_benefits_includes: 'Incluye también beneficios Premium Plus+',
    book_drive_go: 'Reservar Drive & Go',
    distance_allowance: 'Distancia permitida',
    duration: 'Duración',
    view_more_bookings: 'Ver más reservas',
    to_pay_on_arrival: 'A pagar al llegar',
    pay_on_arrival: 'Pagar al llegar',
    unlimited: 'Ilimitado',
    return_date: 'Fecha de devolución',
    postcode: 'Código postal',
    country: 'País',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Drive & Go solo está disponible actualmente para personas con documentos de identidad y licencia de conducir de los siguientes países:',
        drive_and_go_today: '¡Reserva Drive & Go para hoy!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: '¿Por qué usar Drive & Go?',
        straight_to_car: 'Directo al coche',
        no_queues: 'Sin colas',
        self_checkout: 'Auto check-out',
        cannot_lose_the_key: 'No se puede perder la llave',
        online_id_check: 'Verificación de identidad en línea',
        phone_as_a_key: 'Teléfono como llave',
        premium_plus_benefits_also_included: 'Incluye también beneficios Premium Plus+',
        book_drive_and_go: 'Reservar Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Tienda de campaña y equipo',
        quick_and_easy: 'Rápida y fácil de montar',
        travel_freedom: 'Libertad de viaje',
        affordable_campervan_alternative: 'Alternativa asequible a la autocaravana',
        lightweight_and_compact: 'Ligera y compacta',
        fully_insured: 'Totalmente asegurado',
    },
    my_bookings: 'Mi reserva',
    no_bookings: 'Sin reservas',
    my_profile: 'Mi perfil',
    no_bookings_to_display: 'No hay reservas para mostrar.',
    search_great_car_rental_deals: 'Busque excelentes ofertas de alquiler de coches para su próximo viaje.',
    odometer_at_collection: 'Odómetro al recoger',
    fuel_at_collection: 'Combustible al recoger',
    start_check_in: 'Iniciar check-in',
    start_collection: 'Iniciar recogida',
    recent_bookings: 'Reserva reciente',
    damage: {
        updated_damage_report_submitted: 'Se ha enviado un informe de daños actualizado. Un miembro de nuestro equipo de atención al cliente se pondrá en contacto si es necesario.',
        add_additional_damage: 'Agregar daño adicional',
        you_may_report_additional_damage_up_to: 'Puede informar daños adicionales hasta 24 horas después de la devolución del vehículo',
        specify_damage: 'Especificar daño',
        please_choose_the_area_and_type_of_damage: 'Por favor, elija el área y el tipo de daño',
        type_of_damage: 'Tipo de daño',
        is_this_more_than_5_cm: '¿Es esto más de 5 cm?',
        please_take_or_select_a_photo: 'Por favor, tome o seleccione una foto',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Por favor, tome una foto asegurándose de que el daño sea claramente visible',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Si lo necesita, puede agregar otra foto, seleccione el icono para agregar otra foto',
        save_image: 'Guardar imagen',
        save_images: 'Guardar imágenes',
        damage_saved_successfully: 'Daño guardado correctamente',
        add_photo: 'Agregar foto',
    },
    checkout: {
        start_collection: 'Iniciar recogida',
        collect_vehicle: 'Recoger vehículo',
        we_will_let_you_know_the_details: 'Le informaremos la ubicación y los detalles para que pueda encontrar el vehículo de alquiler.',
        inspect: 'Inspeccionar',
        we_will_ask_for_four_photos_from_each_corner: 'Le pediremos cuatro fotos de cada esquina del vehículo, así como de cualquier daño nuevo no listado.',
        fuel_and_milage: 'Combustible y kilometraje',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Confirma las lecturas del odómetro y el combustible al inicio del alquiler.',
        sign: 'Firmar',
        sign_the_rental_agreement: 'Firmar el contrato de alquiler.',
        away_you_go: '¡Listo para salir!',
        you_are_free_to_take_to_the_road: '¡Puede salir a la carretera!',
        collect_your_vehicle: 'Recoja su vehículo',
        get_directions: 'Obtener direcciones',
        hide_directions: 'Ocultar direcciones',
        local_time: 'hora local',
        tel: 'Tel',
        getting_to_the_location: 'Cómo llegar a la ubicación',
        get_vehicle_details: 'Obtener detalles del vehículo',
        view_map: 'Ver mapa',
        unlock_vehicle_and_continue: 'Desbloquear vehículo y continuar',
        unable_to_connect_to_vehicle: 'No se puede conectar con el vehículo',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'No pudimos conectar con el vehículo; por favor, verifique que está junto al vehículo correcto e intente de nuevo.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'No pudimos encontrar la reserva del vehículo. Por favor, inténtelo más tarde.',
        odometer_and_fuel: 'Odómetro y combustible',
        odometer: 'Odómetro',
        please_confirm_the_odometer_and_fuel_readings: 'Si es posible, confirme las lecturas del odómetro y el combustible.',
        the_odometer_field_is_required: 'El campo del odómetro es obligatorio',
        and_must_be_greater_than_the_checkout_odometer: 'y debe ser mayor que el odómetro al recoger',
        confirm: 'Confirmar',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Por favor, tome una foto de cada esquina del vehículo',
        pre_existing_damage: 'Daños preexistentes',
        no_pre_existing_damage: 'No hay daños preexistentes.',
        new_damage: 'Daño nuevo',
        add_additional_damage: 'agregar daño adicional',
        no_new_damage_to_report: 'No hay daños nuevos que reportar',
        checkout_complete: 'Check-out completo',
        start_rental: 'Iniciar alquiler',
        congratulations_name_it_is_time_to_take_to_the_road: '¡Felicidades {customer_name}, es hora de salir a la carretera!',
        we_are_unable_to_complete_your_vehicle_checkout: 'No podemos completar el check-out de su vehículo.',
        please_do_the_following: 'Por favor, haga lo siguiente',
        remove_all_belonging_and_lock_the_vehicle: 'Retire todas sus pertenencias y cierre el vehículo.',
        lock_vehicle: 'Cerrar vehículo',
        once_you_have_contacted_customer_services: 'Una vez que haya contactado con atención al cliente',
        vehicle_location: 'Ubicación del vehículo',
        collect_your: 'Recoja su',
        from: 'De',
        key_in_glove_box: 'su llave está en la guantera',

        keyholder: {
            not_detected: 'Llave no detectada en el portallaves',
            not_detected_please_try_again: 'Por favor, coloque su llave en el portallaves y vuelva a intentarlo.',

            not_installed: 'Portallaves no instalado',
            not_installed_please_contact_customer_service: 'El portallaves no está instalado, por favor contacte con atención al cliente.',
        },
        keyring: {
            look_up_failed: 'Búsqueda de llavero fallida',
            look_up_failed_please_contact_customer_service: 'La búsqueda de llavero falló, por favor contacte con atención al cliente.',
        },
        key: {
            invalid: 'La llave no es válida',
            invalid_please_contact_customer_service: 'Su llave no es válida, por favor contacte con atención al cliente.',

            expired: 'La llave ha expirado',
            expired__please_contact_customer_service: 'Su llave ha expirado, por favor contacte con atención al cliente.',
        },
    },
    checkin: {
        start_check_in: 'Iniciar check-in',
        vehicle_location: 'Ubicación del vehículo',
        tell_us_where_you_have_parked: 'Díganos dónde ha aparcado el vehículo.',
        fuel_and_milage: 'Combustible y kilometraje',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Confirma las lecturas del odómetro y el combustible al final del alquiler.',
        inspect: 'Inspeccionar',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage:
            'Le pediremos cuatro fotos de cada esquina del vehículo, así como de cualquier daño nuevo ocurrido durante el alquiler.',
        lock: 'Cerrar',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Verifique que no ha dejado pertenencias y luego cierre el vehículo.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Por favor, díganos dónde ha aparcado el vehículo',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Una vez que el vehículo esté cerrado, no podrá volver a abrirlo.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            '{first_name}, verifique que no ha dejado pertenencias, cierre el vehículo y, si es necesario, devuelva la llave física al portallaves.',
        lock_vehicle: 'Cerrar vehículo',
        complete_check_in: 'Completar check-in',
        inspection: 'Inspección',
        complete_vehicle_check_in: 'Completar check-in del vehículo',
        we_are_unable_to_complete_your_vehicle_check_in: 'No podemos completar el check-in de su vehículo.',
        please_contact_customer_services: 'Por favor, contacte con atención al cliente',
        once_you_have_contacted_customer_services: 'Una vez que haya contactado con atención al cliente',
        please_amend_odometer_to_be_greater_than: 'Por favor, modifique el odómetro para que sea mayor que {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Contrato de alquiler',
        agreement_between: 'Acuerdo entre',
        and: 'y',
        sign_rental_agreement: 'Firmar contrato de alquiler',
        i_have_read_and_understood_the_terms_and_conditions: 'He leído y entendido los Términos y Condiciones y acepto el estado del vehículo',
    },
    additional_options: 'Opciones adicionales',
    booking_details: 'Detalles de la reserva',
    price_for_x_days: 'Precio por {qty_of_days} día | Precio por {qty_of_days} días',
    cancelled: 'Cancelada',
    upcoming: 'Próxima',
    active: 'Activa',
    full_insurance_no_deposit: 'Seguro completo y sin depósito requerido',
    excess: '{amount} franquicia',
    deposit: '{amount} depósito',
    included_daily_distance: '{distance} {unit} por día',
    miles: 'millas',
    kilometers: 'kilómetros',
    collection_details_title: 'Detalles de recogida',
    collection_details_not_found: 'No hay detalles de recogida definidos para esta ubicación',
    free_cancellation: 'Cancelación gratuita',
    no_deposit: 'Sin depósito',
    benefit_from: 'Benefíciese de',
    for_only_per_day: 'Por solo {price} al día',
    upgrade_mee: 'UpgradeMee',
};
